import { cn } from '@/lib/utils'

import { Skeleton, usePromoBlockVariants } from '../../../Theme'

import type { PromoBlockSkeletonProps } from '../../types'

export function PromoBlockSkeleton({ className }: PromoBlockSkeletonProps) {
  const {
    promoBlockSectionVariants,
    promoBlockImageSectionVariants,
    promoBlockSkeletonContentVariants,
    promoBlockSkeletonInnerVariants,
  } = usePromoBlockVariants()

  return (
    <section
      className={cn(promoBlockSectionVariants(), className)}
      aria-busy="true"
      aria-label="Loading promotional content"
    >
      <div className={promoBlockImageSectionVariants()}>
        <Skeleton className="h-full w-full" />
      </div>

      <div className={promoBlockSkeletonContentVariants()}>
        <div className={promoBlockSkeletonInnerVariants()}>
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-8 w-28" />
        </div>
      </div>
    </section>
  )
}
